export enum EDateTimePickerMode {
	time = "time",
	date = "date",
	datetime = "datetime"
}